var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hg-footer-new',{staticClass:"footer-margin",attrs:{"activate-cookie-consent":!_vm.noCookieConsent,"lang":_vm.$i18n.locale},on:{"onCookieButtonClick":_vm.cookieButtonClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }